<template>
	<div class="home_care_wrap">
        <div class="care_entry">
            <div class="hotly_care">
               <!--  <dl>
                    <dt>快速创建关怀</dt>
                    <dd>无预算的员工关怀场景，可直接一键创建全员计划，节日当天发放。</dd>
                </dl>
                <a target="_blank" class="btn btn-default hotly_care_btn">一键关怀</a> -->
                <a v-if="enterData" :href="enterData.url" target="_blank">
                    <img :src="enterData.content" alt="">
                </a>
            </div>   
            <div class="care_date" @click="showDateFun">
                <em class="date_icon">{{today}}</em>
                <div class="detail">
                    <div class="arrow_box">关怀日历<i class="arrow_icon" :class="{up:toggle}"></i></div>
                    <p>农历{{getLunarMonth(currentYear,currentMonth,today)}}{{getLunarDay(currentYear,currentMonth,today)}}</p>
                </div>
            </div>
        </div>
        <div class="date_show_wrap" v-if="toggle">
            <div class="oper_bar">
                <div class="year_select">
                    <label>{{dateSelect.year}}年<i class="icon-ng icon-ng-go_down"></i></label>
                    <select v-model="dateSelect.year">
                        <option v-for="(i,index) in yearSpan+1" :value="baseYear+index">{{baseYear+index}}年</option>
                    </select>
                </div>
                <div class="show">
                    <div v-if="selectedStatus==1" class="month_select">
                        <i class="arrow_left icon-ng icon-ng-go_left" @click="operMonth('minus')"></i>
                        <span>{{dateSelect.month}}月</span>
                        <i class="arrow_right icon-ng icon-ng-go_right" @click="operMonth('plus')"></i>
                    </div>
                    <h2 v-else>关怀日历</h2>
                </div>
                <div class="y_m_choice">
                    <ul v-if="selectedStatus==1">
                        <li @click="switchDate('month')">本月</li>
                        <li @click="switchDate('year')">全年</li>
                    </ul>
                    <a v-else class="back_month_btn" @click="switchDate('month')">返回本月</a>
                </div>
            </div>
            <div class="date_content">
                <singMonth v-if="selectedStatus==1" :year="dateSelect.year" :month="dateSelect.month"></singMonth>
                <allMonth v-else :year="dateSelect.year" @toggleMonth="toggleToMonthFun"></allMonth>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
import allMonth from './allMonth.vue'
import singMonth from './singMonth.vue'
import {
    mapGetters,
    mapActions
} from 'vuex'
export default{
	props:{

	},
	data() {
        return { 
           baseYear:2017,
           plusYear:3,
           dateSelect:{
              year:new Date().getFullYear(),
              month:new Date().getMonth()+1
           },
           selectedStatus:1,//1月份，2全年,
           toggle:false,
        }
    },
    components:{
      allMonth,
      singMonth
    },
    computed:{
         ...mapGetters({
            getinfo:'getInfos',
        }),
        today(){
            return new Date().getDate();
        },
        currentYear(){
            return new Date().getFullYear();
        },
        currentMonth(){
            return new Date().getMonth()+1;
        },
        yearSpan(){
            return new Date().getFullYear()+this.plusYear-this.baseYear;
        },
        enterData(){
            return this.getinfo.ad;
        }
    },
    methods:{
        getLunarDay(year,month,day){
            return this.$calendar.solar2lunar(year,month,day).IDayCn;
        },
        getLunarMonth(year,month,day){
            return this.$calendar.solar2lunar(year,month,day).IMonthCn;
        },
    	switchDate(type){
            if(type=='month'){
                this.selectedStatus=1;
                this.dateSelect.month=new Date().getMonth()+1;
                this.dateSelect.year=new Date().getFullYear()
            }else{
                this.selectedStatus=2;
            }
        },
        operMonth(type){
            if(type=='minus'){
                if(this.dateSelect.month>1){
                    this.dateSelect.month--;
                }else if(this.dateSelect.year>this.baseYear){
                    this.dateSelect.month=12;
                    this.dateSelect.year--
                }
                
            }
            if(type=='plus'){
                console.log("plus year",this.baseYear+this.yearSpan)
                if(this.dateSelect.month<12){
                    this.dateSelect.month++;
                }else if(this.dateSelect.year<(this.baseYear+this.yearSpan)){
                    this.dateSelect.month=1;
                    this.dateSelect.year++
                }
                
            }
        },
        showDateFun(){
            this.toggle=!this.toggle;
            if(this.toggle){
                this.dateSelect={
                  year:new Date().getFullYear(),
                  month:new Date().getMonth()+1
               };
                this.selectedStatus=1
            }
        },
        toggleToMonthFun(params){
            this.selectedStatus=1;
            this.dateSelect.year=params.year;
            this.dateSelect.month=params.month;
        }
    },
    created(){
        // this.$store.dispatch('loadHomeDatas');
    }
}
</script>
<style lang="scss">
%clearfix{
    display:table; 
    clear:both;
    content:"";
}
$borderColor:#e1e1e1;
.home_care_wrap{
    position:relative;
    .care_entry{
        margin:20px 0;
       &:after{
        @extend %clearfix;
       } 
       .hotly_care{
        height:90px;
         position:relative;
         width:704px;
         float:left;
         background-color: #fff;
         border-radius:4px;
         box-shadow:0 4px 4px 0 rgba(0,0,0,.06), 0 -1px 4px 0 rgba(0,0,0,.06);
         a{
            display:block;
            border-radius:4px;
            img{
                height:90px;
                width:100%;
                border-radius:4px;
            }
         }
        // dt{
        //     margin-bottom:12px;
        //     color:#333;
        //     font-size:16px;
        // }
        // dd{
        //     font-size:12px;
        //     color:#999;
        // }
        //  .hotly_care_btn{
        //     position:absolute;
        //     top:26px;
        //     right:20px;
        //  }
       }
       .care_date{
        height:90px;
        padding-top:15px;
         float:right;
         width:224px;
         background-color: #fff;
         border-radius:4px;
         cursor:pointer;
         box-shadow:0 4px 4px 0 rgba(0,0,0,.06), 0 -1px 4px 0 rgba(0,0,0,.06);
         .date_icon{
            display:inline-block;
            margin-left:26px;
            padding-top:15px;
            width:58px;
            height:58px;
            vertical-align:middle;
            text-align:center;
            font-style: normal;
            font-size:26px;
            font-weight: bold;
            color:#fe8685;
            background:transparent url('../assets/img/date_icon.png') left top no-repeat;
         }
         .detail{
            display:inline-block;
            height:58px;
            vertical-align:middle;
            margin-left:12px;
            .arrow_box{
                margin-bottom:10px;
                color:#333;
                font-size:16px;
            }
            p{
                font-size:12px;
                color:#999;
            }
            .arrow_icon{
                position:relative;
                top: 13px;
                left: 10px;
                border-width: 7px;
                border-color:#ff7678 transparent transparent transparent;
                border-style:solid dashed dashed dashed;
                &.up{
                    top:-13px;
                    border-color:transparent transparent #ff7678 transparent;
                    border-style:dashed dashed solid dashed;
                }
            }
         }
       }
    }
    
    .date_show_wrap{
        background-color:#fff;
        position:absolute;
        width:100%;
        top:110px;
        z-index:10;
        border-radius:4px;
        box-shadow:0 3px 4px 0 rgba(0,0,0,.06), 0 -3px 4px 0 rgba(0,0,0,.06);
        .oper_bar{
            padding:15px 20px;
            border-bottom:1px solid $borderColor;
            ::selection{
                background:transparent;
            }
        }
        .year_select{
            display:inline-block;
            vertical-align:middle;
            position:relative;
            width:110px;
            height:26px;
            label{
                width:110px;
                display:block;
                border:1px solid $borderColor;
                border-radius:4px;
                color:#333;
                font-size:16px;
                text-align:center;
                i{
                    color:#666;
                    margin-left:8px;
                }
            }
            select{
                position:absolute;
                top:0;
                left:0;
                width:100%;
                height:100%;
                z-index:1;
                opacity:0;
                cursor:pointer;
            }
        }
        .show{
            position:absolute;
            left:50%;
            top:15px;
            margin-left:-102px;
            .month_select{
                padding:0 20px;
                text-align:center;
                span{
                    display:inline-block;
                    width:118px;
                    vertical-align:middle;
                    font-size:20px;
                    font-weight:bold;
                    color:#333;
                }
                i{
                    display:inline-block;
                    width:26px;
                    vertical-align:middle;
                    color:#e1e1e1;
                    font-size: 24px;
                    font-weight: bold;
                    cursor:pointer;
                    &:hover{
                        color:#999;
                    }
                }
            }
            h2{
                font-size:16px;
                color:#333;
                font-weight:bold;
                text-align:center;
                margin-left:70px;
            }
        }
        .y_m_choice{
            position:absolute;
            right:20px;
            top:15px;
            ul{
                &:after{
                    @extend %clearfix;
                }
            }
            li{
                float:left;
                width:55px;
                height:30px;
                line-height:30px;
                text-align:center;
                color:#3dd0ff;
                border:1px solid $borderColor;
                cursor:pointer;
                &:first-child{
                    border-top-left-radius: 4px;
                    border-bottom-left-radius: 4px;
                }
                &:last-child{
                    border-left: 0;
                    border-top-right-radius: 4px;
                    border-bottom-right-radius: 4px;
                }
            }
            .back_month_btn{
                display:inline-block;
                width:108px;
                height:30px;
                line-height:30px;
                font-size:13px;
                text-align:center;
                color:#3dd0ff;
                border:1px solid #5cd2fa;
                border-radius:4px;
            }
        }
    }
}
</style>	
